// bridge 自带多链，独立于 contract 配置
import {
    // OnBlock,
    CreateProviderForRpc,
    GetGlobalSigner,
    ResetGlobalSigner,
    SetDefault,
    DEFAULT_ACCOUNT,
    DEFAULT_CHAIN_ID
} from './e'
// } from '../../ethers/e'

import {ethers} from 'ethers'
import { useEffect, createContext, useContext, useState, useMemo} from "react";

import { useAccount, useBlockNumber, useConnectorClient } from 'wagmi'


function clientToSigner(client) {
    const { account, chain, transport } = client
    const network = {
      chainId: chain.id,
      name: chain.name,
      ensAddress: chain.contracts?.ensRegistry?.address,
    }
    const provider = new ethers.providers.Web3Provider(transport, network)
    const signer = provider.getSigner(account.address)
    return signer
  }

let _blockListenList = new Map()
let _lastBlock = 0
function useEthersProvider({ chainId: _chainId, rpc}) {
    
    const [{unlock, wallet}, setChain] = useState(() => {
        // init globl provider
        SetDefault({rpc, chainId: _chainId})
        ResetGlobalSigner(
            CreateProviderForRpc(rpc)
        )
        return {
            account: DEFAULT_ACCOUNT,
            chainId: _chainId || DEFAULT_CHAIN_ID,
            unlock: false, // false 未解锁， true 已解锁
            wallet: null // null 未安装钱包， string 钱包名称
        }
    })

    const acc = useAccount()
    const account = acc.address || DEFAULT_ACCOUNT
    // const account = '0x711Aa0a34016Daa119A1C638cfd2C752A9a33342'
    // console.log(acc.address, " address")
    // 用 useConnectorClient 重置 provider
    const { data: walletClient} = useConnectorClient()

    // console.log(acc, ' gsa ', block.data, walletClient)
    useEffect(() => {
        if (walletClient && walletClient.transport) {
            const pro = clientToSigner(walletClient)
            ResetGlobalSigner(pro)
        }
    }, [walletClient])

    // 初始化本地钱包
    useEffect(() => {
        let _polling = true
        SetDefault({rpc, chainId: _chainId})
        // return
        // return
        const init = async () => {
            let signer = GetGlobalSigner()
           
            if (_polling === false) return
            if ( signer.provider === undefined ) {
                setTimeout(init, 1000)
            }
            else {
                // 已安装钱包
                try {

                    
                    let _newBlockNumber = await signer.provider.getBlockNumber()

                    // 监听区块，切换 chainId 时，OnBlock 会报错 提示
                    // 这里不使用 setBlock hook, 因为 setBlock 会导致页面刷新
                    if ( _lastBlock !== _newBlockNumber ) {
                        _lastBlock = _newBlockNumber
                        _blockListenList.forEach((_,v) => v(_newBlockNumber))
                    }
                    setTimeout(init, 1000)
                } catch (error) {
                    // 切换网络时，会报错，此时需要重新初始化
                    console.error(error.message, ' poll error')
                    const errorInfo = error.message
                    // 切换网络时，会报错，此时需要重新初始化
                    if (errorInfo.match("underlying network changed")) {
                        signer = GetGlobalSigner()
                        // init()
                        setTimeout(init, 1000)
                    }
                    else if (errorInfo.match("unknown account")) {
                        console.log("unknown account")
                        // signer = ResetGlobalSigner()
                        // 断开钱包
                        setChain({
                            account: DEFAULT_ACCOUNT,
                            chainId: DEFAULT_CHAIN_ID,
                            unlock: false,
                            wallet: null
                        })
                        setTimeout(init, 1000)
                        // init()
                    }
                    // 其它报错 不再循环
                }
            }
        }
        init()

        // const {stop} = OnBlock(signer.provider, (_fromBlock, _toBlock) => {
        //     _lastBlock = _toBlock
        //     _blockListenList.forEach((_,v) => v(_toBlock))
        // })
        return () => {
            _polling = false
            _blockListenList = new Map()
            _lastBlock = 0
            // stop()
        }
    }, [_chainId, rpc])

    const addBlockListen = (cb) => {
        // 开发者模式时 StrictMode 导致出现重复添加的情况，是正常的
        if (_blockListenList.get(cb)) return
        _blockListenList.set(cb, true)
    }

    const removeBlockListen = (cb) => {
        if (_blockListenList.has(cb)) {
            _blockListenList.delete(cb)
        }
    }
    const connect = () => {
        if (wallet || !unlock) {
            const signer = GetGlobalSigner()
            signer.provider.provider.enable()
            ResetGlobalSigner()
        }
    } 

    return {
        unlock: account !== DEFAULT_ACCOUNT,
        account,
        addBlockListen,
        removeBlockListen,
        connect
    }
}

const Context = createContext({})

function useEthers() {
    const pro = useContext(Context)
    const [, setBlockNubmer] = useState(_lastBlock)

    const getBlockNumber = () => {
        pro.addBlockListen(setBlockNubmer)
        return _lastBlock
    }

    useEffect(() => {
        return () => {
            pro.removeBlockListen(setBlockNubmer)
        }
    },[])

    return {
        ...pro,
        getBlockNumber
    }
}

function EthersProvider({chainId, rpc, children }) {
    const pro = useEthersProvider({ chainId, rpc })
    return(
        <Context.Provider
            value={pro}
        >
            {children}
        </Context.Provider>
    )
}

export default EthersProvider

export {
    Context,
    useEthers
}
